import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import {
  Box,
  Flex,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  useToast
} from '@chakra-ui/react'
import { Heading, Button } from '../../components/UI'
import { AddUserIcon, CheckUserIcon } from '../../components/Icons'
import TablePartners from '../../components/TablePartners'
import FiltersPartners from '../../components/FiltersPartners'
import PayrollDownload from './Billing/PayrollDownload'
import Rates from './Billing/Rates'
import CollectionUpload from './Billing/CollectionUpload'
import { billingRoles } from './Billing/shared'

const Partners = () => {
  const toast = useToast()
  const [tab, setTab] = useState(0)
  const { user } = useSelector((s) => s.auth)
  const canViewBilling = billingRoles.includes(user?.role)
  const initialFiltersPartners = {
    search: '',
    startDate: '',
    endDate: '',
    grade: 'Todos los Grados',
    state: '',
    from: 'PRIMARY-LIST',
    partnerCreationType: ''
  }
  const [filtersPartners, setFiltersPartners] = useState(initialFiltersPartners)
  useEffect(() => {
    toast.closeAll()
  }, [toast])
  const listing = (
    <>
      <Box borderBottom="1px solid" borderColor="green.500" pb={1}>
        <FiltersPartners
          filtersPartners={filtersPartners}
          setFiltersPartners={setFiltersPartners}
          initialFiltersPartners={initialFiltersPartners}
        >
          <Flex gap={2} wrap="wrap" minW={0}>
            <Link to="/partners/create">
              <Button
                mx={0}
                size="sm"
                py={4}
                px={3}
                text="Nuevo Socio"
                icon={AddUserIcon}
              />
            </Link>
            <Link to="/partners/upload">
              <Button
                mx={0}
                size="sm"
                py={4}
                px={3}
                text="Actualización de socios"
                icon={CheckUserIcon}
              />
            </Link>
          </Flex>
        </FiltersPartners>
      </Box>
      <Box minW={0}>
        <TablePartners filtersPartners={filtersPartners} />
      </Box>
    </>
  )
  return (
    <Flex data-page="partners" direction="column" minW={0} pb={2}>
      <Box sx={{ '& > div': { px: 0, mb: 2 }, '& p': { ml: 0 } }}>
        <Heading title="SOCIOS" />
      </Box>
      {canViewBilling ? (
        <Tabs
          index={tab}
          onChange={setTab}
          variant="soft-rounded"
          colorScheme="green"
          isLazy
        >
          <Flex
            align="center"
            justify="space-between"
            gap={3}
            wrap="wrap"
            py={2}
            mb={2}
          >
            <TabList gap={1} flexWrap="wrap" minW={0}>
              {[
                'Listado de socios',
                'Rangos y descuentos',
                'Carga de cobro'
              ].map((label) => (
                <Tab
                  key={label}
                  color="green.500"
                  borderRadius={12}
                  py={2}
                  _selected={{ bg: 'beige.500', color: 'green.500' }}
                  _hover={{ bg: 'beige.600' }}
                >
                  {label}
                </Tab>
              ))}
            </TabList>
            <PayrollDownload section={tab} />
          </Flex>
          <TabPanels minW={0}>
            <TabPanel p={0}>{listing}</TabPanel>
            <TabPanel p={0}>
              <Rates />
            </TabPanel>
            <TabPanel p={0}>
              <CollectionUpload />
            </TabPanel>
          </TabPanels>
        </Tabs>
      ) : (
        <Box pt={6}>{listing}</Box>
      )}
    </Flex>
  )
}
export default Partners
